import Button, { ButtonProps } from '@mui/material/Button';
import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './styles.module.scss';

type Props = {
  auth?: boolean;
} & ButtonProps;

const CustomButton: FC<Props> = ({ auth = false, className, sx, children, ...rest }): JSX.Element => {
  return (
    <Button
      className={clsx(styles.generalButton, className, { [styles.authBtn]: auth })}
      sx={{
        textTransform: 'none',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
